module.exports = __webpack_public_path__ + "static/media/contactact.d5734aa2.svg";